export const generateMapSettings = (redemptionUnit, newInteractiveMapProps) => {
  const isLoyalty = redemptionUnit === 'POINTS' || redemptionUnit === 'MILES';
  const showPrice = !isLoyalty;
  const showMiles = isLoyalty;

  return {
    ...newInteractiveMapProps,
    fareList: {
      ...newInteractiveMapProps?.fareList,
      itemSettings: {
        ...newInteractiveMapProps?.fareList?.itemSettings,
        showPrice: showPrice,
        showMiles: showMiles,
        fareItemMiles: {
          ...newInteractiveMapProps?.fareList?.itemSettings?.fareItemMiles,
          milesSymbol: redemptionUnit?.toLowerCase()
        }
      }
    },
    vectorMapSettings: {
      ...newInteractiveMapProps?.vectorMapSettings,
      endRouteSettings: {
        ...newInteractiveMapProps?.vectorMapSettings?.endRouteSettings,
        fareItemCardSettings: {
          ...newInteractiveMapProps?.vectorMapSettings?.endRouteSettings?.fareItemCardSettings,
          showPrice: showPrice,
          showMiles: showMiles,
          fareItemMiles: {
            ...newInteractiveMapProps?.vectorMapSettings?.endRouteSettings?.fareItemCardSettings
              ?.fareItemMiles,
            milesSymbol: redemptionUnit?.toLowerCase()
          }
        }
      },
      markersSettings: {
        ...newInteractiveMapProps?.vectorMapSettings?.markersSettings,
        fareMarkerSettings: {
          ...newInteractiveMapProps?.vectorMapSettings?.markersSettings?.fareMarkerSettings,
          fareItemCardSettings: {
            ...newInteractiveMapProps?.vectorMapSettings?.markersSettings?.fareMarkerSettings
              ?.fareItemCardSettings,
            showPrice: showPrice,
            showMiles: showMiles,
            fareItemMiles: {
              ...newInteractiveMapProps?.vectorMapSettings?.markersSettings?.fareMarkerSettings
                ?.fareItemCardSettings?.fareItemMiles,
              milesSymbol: redemptionUnit?.toLowerCase()
            }
          }
        }
      }
    }
  };
};
